"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const functions_1 = require("../functions");
const parser_1 = require("../grammar/parser");
function parse(formula) {
    return (0, parser_1.parse)(formula, (0, functions_1.getParserOptions)());
}
//# sourceMappingURL=index.js.map